import { dataEyeTrackingSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconEyeTrackingSolid = /*#__PURE__*/createIcon(dataEyeTrackingSolid)
export default IconEyeTrackingSolid
